const DEFAULT_ICON_URL =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMWVtIiBoZWlnaHQ9IjFlbSIgdmlld" +
  "0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcv" +
  "MjAwMC9zdmciPgogIDxwYXRoCiAgICBmaWxsPSJjdXJyZW50Q29sb3IiCiAgICBkPSJNNi4" +
  "xMSA1LjUxNmMuMjQ2LS4zNi4zOS0uNzk3LjM5LTEuMjY2QzYuNSAzLjAwNyA1LjQ5MyAyID" +
  "QuMjUgMlMyIDMuMDA3IDIgNC4yNSAzLjAwNyA2LjUgNC4yNSA2LjVjLjMyIDAgLjYyMy0uM" +
  "DY2Ljg5OC0uMTg2bDMuNTc1IDQuMTc1Yy0uNDEuNDYtLjY5MiAxLjAzOC0uNzg3IDEuNjc4" +
  "bC0xLjYzLjE3QzUuOTU3IDExLjU0OSA1LjE2OCAxMSA0LjI1IDExIDMuMDA3IDExIDIgMTI" +
  "uMDA3IDIgMTMuMjVzMS4wMDcgMi4yNSAyLjI1IDIuMjVjMS4xMzIgMCAyLjA2OS0uODM2ID" +
  "IuMjI3LTEuOTI0bDEuNTE0LS4xNThjLjE3OS43MzguNjEgMS4zNzcgMS4xOTYgMS44MjNsL" +
  "TEuMDUgMi4yOTJjLS4xMjUtLjAyMi0uMjU1LS4wMzMtLjM4Ny0uMDMzLTEuMjQzIDAtMi4y" +
  "NSAxLjAwNy0yLjI1IDIuMjVTNi41MDcgMjIgNy43NSAyMiAxMCAyMC45OTMgMTAgMTkuNzV" +
  "jMC0uNjYxLS4yODUtMS4yNTYtLjc0LTEuNjY3bDEuMDUtMi4yOTNjLjI2OC4wNzIuNTUuMT" +
  "EuODQuMTEuNzEzIDAgMS4zNzMtLjIzIDEuOTEtLjYybDMuMjAyIDIuOTE2Yy0uMTY3LjMxN" +
  "C0uMjYyLjY3My0uMjYyIDEuMDU0IDAgMS4yNDMgMS4wMDcgMi4yNSAyLjI1IDIuMjVzMi4y" +
  "NS0xLjAwNyAyLjI1LTIuMjVTMTkuNDkzIDE3IDE4LjI1IDE3Yy0uNDA3IDAtLjc4OS4xMDg" +
  "tMS4xMTguMjk3bC0zLjIyMS0yLjkzMmMuMzEtLjQ5OC40ODktMS4wODUuNDg5LTEuNzE1ID" +
  "AtLjA0MyAwLS4wODYtLjAwMy0uMTI4bDMuMzktLjY3MmMuMzg1LjY4NyAxLjEyIDEuMTUgM" +
  "S45NjMgMS4xNSAxLjI0MyAwIDIuMjUtMS4wMDcgMi4yNS0yLjI1UzIwLjk5MyA4LjUgMTku" +
  "NzUgOC41Yy0xLjIwMyAwLTIuMTg2Ljk0NC0yLjI0NyAyLjEzMmwtMy4zOTQuNjczYy0uMjU" +
  "4LS41NjctLjY3NC0xLjA0Ni0xLjE5MS0xLjM4M2wuNjM5LTEuNDNjLjA2My4wMDUuMTI4Lj" +
  "AwOC4xOTMuMDA4QzE0Ljk5MyA4LjUgMTYgNy40OTMgMTYgNi4yNVMxNC45OTMgNCAxMy43N" +
  "SA0IDExLjUgNS4wMDcgMTEuNSA2LjI1YzAgLjczMS4zNDkgMS4zOC44ODkgMS43OTJsLS42" +
  "MzIgMS40MTVjLS4xOTctLjAzOC0uNC0uMDU3LS42MDctLjA1Ny0uNTEzIDAtLjk5OS4xMTk" +
  "tMS40My4zM0w2LjExIDUuNTE3eiIKICAvPgo8L3N2Zz4K";

export default DEFAULT_ICON_URL;
